import { render, staticRenderFns } from "./StepOtp.vue?vue&type=template&id=07ae9384&"
import script from "./StepOtp.vue?vue&type=script&lang=js&"
export * from "./StepOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports